<template>
  <div class="app-passivate-sim-card">
    <slot name="txtBefore"></slot>
    <b-overlay class="btn-next-overlay" :show="loading" spinner-small>
      <b-button @click="showModal()" class="btn-next" type="button" variant="primary" :disabled="loading">
        <slot name="btnNext">SIM sperren</slot>
      </b-button>
    </b-overlay>
    <slot name="txtAfter"></slot>
  </div>
</template>

<script>
import slotProxy from '../../../../../mixins/slotProxy'

export default {
  name: 'PassivateSimCard',
  data () {
    return {
      loading: false,
      modalShow: false
    }
  },
  methods: {
    showModal () {
      this.$emit('showmodal')
    }
  },
  mixins: [
    slotProxy()
  ]
}
</script>
